import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43348d73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-10 px-12 pt-0" }
const _hoisted_2 = { class: "flex justify-left font-bold border-solid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "Back", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-5 pb-0 sm:p-5 text-medium sm:text-xl font-bold" }, "Add Bike", -1))
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "grid grid-cols-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "title",
  class: "text-left font-bold text-gray-700"
}, "Title *", -1))
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "year",
  class: "text-left font-bold text-gray-700"
}, "Year *", -1))
const _hoisted_10 = {
  key: 1,
  class: "text-sm text-red-500"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "text-left font-bold text-gray-700"
}, "Description *", -1))
const _hoisted_12 = {
  key: 2,
  class: "text-sm text-red-500"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "price",
  class: "text-left font-bold text-gray-700"
}, "Price €*", -1))
const _hoisted_14 = {
  key: 3,
  class: "text-sm text-red-500"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-left font-bold text-gray-700 pb-3" }, "Images *", -1))
const _hoisted_16 = { class: "bg-white border border-gray-300 rounded-md p-4 w-full h-auto overflow-hidden relative" }
const _hoisted_17 = {
  key: 0,
  class: "w-full h-full flex flex-wrap items-center justify-center"
}
const _hoisted_18 = { class: "text-sm text-gray-600" }
const _hoisted_19 = {
  key: 1,
  class: "w-full h-full flex flex-wrap items-center justify-center"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "text-sm text-red-500 pt-3"
}
const _hoisted_22 = {
  key: 1,
  class: "text-sm text-red-500 pt-3"
}
const _hoisted_23 = { class: "py-8" }
const _hoisted_24 = {
  type: "submit",
  class: "rounded bg-gray-800 px-6 py-2.5 text-xs font-medium uppercase leading-tight text-white shadow-md transition duration-150 ease-in-out hover:bg-primary-700 hover:shadow-lg focus:bg-primary-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-primary-800 active:shadow-lg",
  "data-te-ripple-init": "",
  "data-te-ripple-color": "dark"
}
const _hoisted_25 = {
  key: 0,
  class: "message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ClipLoader = _resolveComponent("ClipLoader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: "cursor-pointer hover:text-red-600",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToAdminPage && _ctx.backToAdminPage(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'chevron-left'],
          class: "pr-2"
        }),
        _hoisted_3
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ClipLoader, {
            key: 0,
            color: _ctx.colorLoading
          }, null, 8, ["color"]))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)), ["prevent"])),
            method: "post",
            class: "add-form",
            novalidate: ""
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event)),
                class: _normalizeClass(["mt-0 block w-full px-0.5 bg-white border-0 border-b-2 border-gray-400 focus:ring-0 focus:border-black text-sm mb-5", {
              'border-red-500': _ctx.v.title.$error && _ctx.submitted,
              'border-gray-400': !_ctx.v.title.$error,
            }]),
                placeholder: "Title *"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.title,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v.title.$dirty && _ctx.v.title.$error && _ctx.submitted)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Title is required and must have max of 50 words "))
                : _createCommentVNode("", true),
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.year) = $event)),
                class: _normalizeClass(["mt-0 block w-full px-0.5 bg-white border-0 border-b-2 border-gray-400 focus:ring-0 focus:border-black text-sm mb-5", {
              'border-red-500': _ctx.v.year.$error && _ctx.submitted,
              'border-gray-400': !_ctx.v.year.$error,
            }]),
                placeholder: "Year *"
              }, null, 2), [
                [_vModelText, _ctx.year]
              ]),
              (_ctx.v.year.$dirty && _ctx.v.year.$error && _ctx.submitted)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Year is required and must be a number "))
                : _createCommentVNode("", true),
              _hoisted_11,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event)),
                class: _normalizeClass(["mt-0 block w-full px-0.5 bg-white border-0 border-b-2 border-gray-400 focus:ring-0 focus:border-black text-sm mb-5", {
              'border-red-500': _ctx.v.description.$error && _ctx.submitted,
              'border-gray-400': !_ctx.v.description.$error,
            }]),
                placeholder: "Description *"
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.description,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v.description.$dirty && _ctx.v.description.$error && _ctx.submitted)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Description is required "))
                : _createCommentVNode("", true),
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.price) = $event)),
                class: _normalizeClass(["mt-0 block w-full px-0.5 bg-white border-0 border-b-2 border-gray-400 focus:ring-0 focus:border-black text-sm mb-5", {
              'border-red-500': _ctx.v.price.$error && _ctx.submitted,
              'border-gray-400': !_ctx.v.price.$error,
            }]),
                placeholder: "Price €*"
              }, null, 2), [
                [_vModelText, _ctx.price]
              ]),
              (_ctx.v.price.$dirty && _ctx.v.price.$error && _ctx.submitted)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Price is required and must be a number "))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.isLoadingImage)
                    ? (_openBlock(), _createBlock(_component_ClipLoader, {
                        key: 0,
                        color: _ctx.colorLoading
                      }, null, 8, ["color"]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onDragover: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.dragOver && _ctx.dragOver(...args))),
                        onDragleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.dragOut && _ctx.dragOut(...args))),
                        onDrop: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.dragDrop && _ctx.dragDrop(...args))),
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.browseFile && _ctx.browseFile(...args)))
                      }, [
                        _createElementVNode("input", {
                          type: "file",
                          class: "hidden",
                          ref: "fileInput",
                          multiple: "",
                          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadFiles && _ctx.uploadFiles(...args)))
                        }, null, 544),
                        (_ctx.files.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("p", _hoisted_18, " Click HERE (max " + _toDisplayString(_ctx.maxImages) + ") ", 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (image, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "relative w-24 h-24 bg-no-repeat bg-center bg-cover m-1 border border-gray-300 rounded-md shadow-sm cursor-pointer overflow-hidden",
                                  style: _normalizeStyle('background-image: url(' + image.preview + ');'),
                                  key: index
                                }, [
                                  _createElementVNode("span", {
                                    class: "bg-gray-800 absolute top-0 right-0 text-white text-xs p-1 cursor-pointer",
                                    onClick: _withModifiers(($event: any) => (_ctx.deleteImage(index)), ["stop"])
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] })
                                  ], 8, _hoisted_20)
                                ], 4))
                              }), 128))
                            ]))
                      ], 32))
                ]),
                (_ctx.isMaxImagesReached)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Maximum image limit (" + _toDisplayString(_ctx.maxImages) + ") is reached. ", 1))
                  : _createCommentVNode("", true),
                (_ctx.v.files.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Minimum of 1 image is required "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", _hoisted_24, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'add'],
                  class: "pr"
                }),
                _createTextVNode(" ADD ")
              ])
            ])
          ], 32))
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}